/* tslint:disable */
/* eslint-disable */
/**
 * Business Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
/* eslint-disable */

/**
* このファイルは自動生成されています。そのためgit管理には含まれません。手動で編集してもdeploy時反映されません。
*/

/**
 * グループ管理マスタのカテゴリタイプ
 * @export
 * @enum {number}
 */
export enum GroupCategoryTypeEnum {
    /** P0 */
    P0 = 0,
    /** API */
    API = 1
}

/**
 * グループ管理マスタのカテゴリタイプ の Union 型
 * @export
 * @typedef GroupCategoryType
 */
export type GroupCategoryType =
  typeof GroupCategoryTypeEnum[keyof typeof GroupCategoryTypeEnum];

/**
 * グループ管理マスタのカテゴリタイプ のラベルマップ
 * @export
 */
export const GroupCategoryTypeLabels = {
    /**
     * 数値キー: GroupCategoryTypeEnum.P0
     * 名前キー:  P0
     */
    [GroupCategoryTypeEnum.P0]: 'P0',
    P0:                             'P0',
    /**
     * 数値キー: GroupCategoryTypeEnum.API
     * 名前キー:  API
     */
    [GroupCategoryTypeEnum.API]: 'API',
    API:                             'API',
} as const;

/**
 * グループ管理マスタのカテゴリタイプ のラベル Union 型
 * @export
 * @typedef GroupCategoryTypeLabel
 */
export type GroupCategoryTypeLabel =
  typeof GroupCategoryTypeLabels[keyof typeof GroupCategoryTypeLabels];

/**
 * グループ管理マスタのカテゴリタイプ のラベル取得関数
 * @export
 * @param { GroupCategoryType } value - 列挙体の値
 * @returns { GroupCategoryTypeLabel } ラベル文字列
 */
export function getGroupCategoryTypeLabel(
  value: GroupCategoryType
): GroupCategoryTypeLabel {
  return GroupCategoryTypeLabels[value];
}

/**
 * グループ管理マスタのカテゴリタイプ のラベル配列を取得する関数
 * @export
 * @param { GroupCategoryType[] } values - 列挙体の値配列
 * @returns { GroupCategoryTypeLabel[] } ラベル文字列配列
 */
export function getGroupCategoryTypeLabels(values: GroupCategoryType[]): GroupCategoryTypeLabel[] {
  return values.map((value) => getGroupCategoryTypeLabel(value));
}

/**
 * グループ管理マスタのカテゴリタイプ のラベル配列
 * @export
 */
export const GroupCategoryTypeLabelList = [
  'P0','API',
] as const;

